import { render, staticRenderFns } from "./AccountJudgment.vue?vue&type=template&id=7bb8cd98&scoped=true&"
import script from "./AccountJudgment.vue?vue&type=script&lang=js&"
export * from "./AccountJudgment.vue?vue&type=script&lang=js&"
import style0 from "./AccountJudgment.vue?vue&type=style&index=0&id=7bb8cd98&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bb8cd98",
  null
  
)

export default component.exports